<template class="no-print print-height">
  <div fluid class="no-print">
    <b-container fluid class="fp-container py-5 my-4 no-print">
      <b-container class="rakenne-form">
        <b-row class="pb-2">
          <b-col sm="6" md="3">
            <p class="m-small">Paloluokka</p>
            <el-select
              v-model="paloluokka"
              placeholder="Valitse"
              @change="filterPart"
            >
              <el-option
                v-for="luokka in getPaloluokat()"
                :label="luokka.label"
                :value="luokka.index"
                :key="luokka.index"
              ></el-option>
            </el-select>
          </b-col>
          <b-col cols="3">
          <span class="m-small">Tilan seinä- ja kattopinnat puuta</span>
            <b-form-checkbox
              v-model="nakyvapuupinta"
              value="9"
              :disabled="puupintaDisabled"
              unchecked-value="10"
              switch
              @input="filterPart"
            >
              <b>{{ puupintaChecked }}</b>
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="py-2 align-items-end">
          <b-col v-for="(data, idx) in rakenneData" :key="idx" sm="6" md="3">
            <p class="m-small">{{ data.title }}</p>
            <el-select
              v-model="data.model"
              placeholder="Valitse"
              @change="filterPart"
            >
              <el-option
                v-for="item in getRakenteet(data.data)"
                :label="item.label"
                :value="item.index"
                :key="item.index"
                v-html="item.text"
              ></el-option>
            </el-select>
          </b-col>
        </b-row>
        <b-row class="pt-3">
          <b-col md="4">
            <router-link to="/ohjeita-rakennetyyppeihin/">Ohjeita rakennetyyppeihin</router-link>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
    <b-container clss="text-center" v-if="loading">
      <b-spinner style="width: 4rem; height: 4rem; color: #006fb9;" label="Lataa..."></b-spinner>
    </b-container>

    <Tyypit :items="items" :paloluokka="paloluokka" :kayttotarkoitus="kayttotarkoitus" :pintaluokat="pintaluokat" />

    <!-- <b-button class="blue-button mt-4 mb-5 no-print">
      Palaa järjestelmiin
    </b-button>-->
  </div>
</template>

<script>
import kayttotarkoitukset from '../data/kayttotarkoitukset.js'
import rakenteet from '../data/rakenteet'
import { paloluokat } from '../data/constants.js'
import Tyypit from './Tyypit.vue'

export default {
  name: 'Rakennetyyppi',
  components: { Tyypit },
  data () {
    return {
      kayttotarkoitukset: kayttotarkoitukset,
      paloluokka: '',
      nakyvapuupinta: '10',
      puupintaDisabled: false,
      pinnat: 'Ei',
      loading: false,
      items: [],
      paloluokat: paloluokat,
      rakenneData: [
        {
          title: 'Rakenne',
          model: '',
          data: rakenteet
        },
        {
          title: 'Ilmaääneneristävyys',
          model: '',
          data: [
            {
              index: '29,24',
              label: '≥ 55 dB',
              text: 'D<sub>nT,w</sub> ≥ 55 dB'
            },
            {
              index: '13,24',
              label: '50…54 dB',
              text: 'D<sub>nT,w</sub> = 50…54 dB'
            },
            {
              index: '12,24',
              label: '45…49 dB',
              text: 'D<sub>nT,w</sub> = 45…49 dB'
            },
            {
              index: '11,24',
              label: '35…44 dB',
              text: 'D<sub>nT,w</sub> = 35…44 dB'
            }
          ]
        },
        {
          title: 'Askelääneneristävyys',
          model: '',
          data: [
            {
              index: '16,25',
              label: '≤ 53 dB',
              text: 'L’<sub>nT,w</sub> + C<sub>I,50-2500</sub> ≤ 53 dB'
            },
            {
              index: '15,25',
              label: '54…59 dB',
              text: 'L’<sub>nT,w</sub> + C<sub>I,50-2500</sub> = 59…54 dB'
            },
            {
              index: '14,25',
              label: '60…65 dB',
              text: 'L’<sub>nT,w</sub> + C<sub>I,50-2500</sub> = 65…60 dB'
            }
          ]
        },
        {
          title: 'Liikennemelun ääneneristävyys',
          model: '',
          data: [
            {
              index: '30,26',
              label: '50…55 dB',
              text: 'R<sub>w</sub> + C<sub>tr</sub> = 50…55 dB'
            },
            {
              index: '19,26',
              label: '45…49 dB',
              text: 'R<sub>w</sub> + C<sub>tr</sub> = 45…49 dB'
            },
            {
              index: '18,26',
              label: '40…44 dB',
              text: 'R<sub>w</sub> + C<sub>tr</sub> = 40…44 dB'
            },
            {
              index: '17,26',
              label: '35…39 dB',
              text: 'R<sub>w</sub> + C<sub>tr</sub> = 35…39 dB'
            }
          ]
        }
      ]
    }
  },
  mounted: function () {
    if (!this.rakenneData[0].model && this.userSelection.rakenne) {
      this.rakenneData[0].model = this.userSelection.rakenne
    }
    if (!this.rakenneData[1].model && this.userSelection.sisainenmelu) {
      this.rakenneData[1].model = this.userSelection.sisainenmelu
    }
    if (!this.rakenneData[2].model && this.userSelection.sisainenmelu1) {
      this.rakenneData[2].model = this.userSelection.sisainenmelu1
    }
    if (!this.rakenneData[3].model && this.userSelection.ulkoinenmelu) {
      this.rakenneData[3].model = this.userSelection.ulkoinenmelu
    }
  },
  computed: {
    kaikki: function () {
      return this.userSelection.kayttotarkoitus === null ? 'Kyllä' : 'Ei'
    },
    kayttotarkoitus: function () {
      return this.userSelection.kayttotarkoitus != null ? this.kayttotarkoitukset[this.userSelection.kayttotarkoitus].label : ''
    },
    puupintaChecked: function () {
      return this.nakyvapuupinta === '9' ? 'Kyllä' : 'Ei'
    },
    pintaluokat: function () {
      var pmobj = {}
      if (this.userSelection.results.p1 !== null && this.paloluokka === '3') {
        pmobj = this.userSelection.results.p1.pintaluokat
      }
      if (this.userSelection.results.p2 !== null && (this.paloluokka === '4' || this.paloluokka === '42')) {
        pmobj = this.userSelection.results.p2.pintaluokat
      }
      if (this.userSelection.results.p3 !== null && this.paloluokka === '5') {
        pmobj = this.userSelection.results.p3.pintaluokat
      }
      return pmobj
    }
  },
  methods: {
    filterPart () {
      this.loading = true

      const rakenne = this.rakenneData[0].model
      const sisainenmelu = this.rakenneData[1].model === '' ? 'Ei valintaa' : this.rakenneData[1].model // 104
      const sisainenmelu1 = this.rakenneData[2].model === '' ? 'Ei valintaa' : this.rakenneData[2].model // 105
      const ulkoinenmelu = this.rakenneData[3].model === '' ? 'Ei valintaa' : this.rakenneData[3].model // 106

      // console.debug(sisainenmelu)

      this.userSelection.rakenne = rakenne
      this.userSelection.sisainenmelu = sisainenmelu
      this.userSelection.sisainenmelu1 = sisainenmelu1
      this.userSelection.ulkoinenmelu = ulkoinenmelu

      if ((rakenne === '7' || rakenne === '8' || rakenne === '27') && this.userSelection.kerrosmaara < 3) {
        if (this.userSelection.kayttotarkoitus !== null) {
          this.nakyvapuupinta = '9'
          this.puupintaDisabled = true
        }
      } else {
        this.puupintaDisabled = false
      }

      const records = 100
      let params = {
        rest_route: '/wp/v2/rakennusosa',
        per_page: records,
        page: 0,
        paloluokka: this.paloluokka,
        nakyva_puupinta_sisalla: this.nakyvapuupinta
      }

      if (rakenne) {
        params.rakenne = rakenne
      }

      if (sisainenmelu !== 'Ei valintaa') {
        params.aanitekniikka_sisainen = sisainenmelu
      }

      if (sisainenmelu1 !== 'Ei valintaa') {
        params.aanitekniikka_sisainen_1 = sisainenmelu1
      }

      if (ulkoinenmelu !== 'Ei valintaa') {
        params.aanitekniikka_ulkoinen = ulkoinenmelu
      }

      this.recursiveFetch(params, records)
    },
    recursiveFetch (params, records) {
      params.page++
      this.fetchData(params, data => {
        this.addItems(data, params.page === 1)
        // console.debug(data.length)
        if (data.length === records) {
          this.recursiveFetch(params, records)
        }
      })
    },
    fetchData (params, callback) {
      // console.debug(params)
      this.axios
        .get('https://epuu.fi/', { params })
        .then(response => {
          this.loading = false
          callback(response.data)
        })
        .catch(error => {
          this.loading = false
          console.debug(error)
        })
    },
    addItems (items, reset = false) {
      if (reset) {
        this.items = []
      }
      items.forEach(item => {
        this.items.push(item)
      })

      if (this.userSelection.sisainenmelu !== 'Ei valintaa') {
        var sm = Number(this.userSelection.sisainenmelu.split(',')[0])
        var smn = Number(this.userSelection.sisainenmelu.split(',')[1])
        this.items = this.items.filter(function (item) {
          return item.aanitekniikka_sisainen.indexOf(sm) >= 0 || item.aanitekniikka_sisainen.indexOf(smn) >= 0
        })
      }

      if (this.userSelection.sisainenmelu1 !== 'Ei valintaa') {
        var sm1 = Number(this.userSelection.sisainenmelu1.split(',')[0])
        var sm1n = Number(this.userSelection.sisainenmelu1.split(',')[1])
        this.items = this.items.filter(function (item) {
          return item.aanitekniikka_sisainen_1.indexOf(sm1) >= 0 || item.aanitekniikka_sisainen_1.indexOf(sm1n) >= 0
        })
      }

      if (this.userSelection.ulkoinenmelu !== 'Ei valintaa') {
        var um = Number(this.userSelection.ulkoinenmelu.split(',')[0])
        var umn = Number(this.userSelection.ulkoinenmelu.split(',')[1])
        this.items = this.items.filter(function (item) {
          return item.aanitekniikka_ulkoinen.indexOf(um) >= 0 || item.aanitekniikka_ulkoinen.indexOf(umn) >= 0
        })
      }
    },
    tagParser (value) {
      return 'Lorem'
    },
    getPaloluokat () {
      return this.paloluokat.filter(palo => {
        if (this.kaikki === 'Kyllä') {
          return true
        }
        switch (palo.class) {
          case 'P1':
            if (this.userSelection.results.p1 !== null && !this.userSelection.results.p1.passed) {
              return false
            }
            break
          case 'P2':
            if (this.userSelection.results.p2 !== null && !this.userSelection.results.p2.passed) {
              return false
            }
            if (palo.value === 'R 30' && this.userSelection.kerrosmaara > 2) {
              return false
            }
            if (palo.value === 'R 60' && this.userSelection.kerrosmaara < 3) {
              return false
            }
            break
          case 'P3':
            if (this.userSelection.results.p3 !== null && !this.userSelection.results.p3.passed) {
              return false
            }
            break
        }
        return true
      }).map(palo => {
        return {
          index: palo.index,
          class: palo.class,
          label: palo.class + ' (' + palo.value + ')'
        }
      })
    },
    getRakenteet (data) {
      const items = data.map(item => {
        return {
          index: item.index,
          label: item.label,
          text: item.text ? item.text : item.label
        }
      })
      items.unshift({
        index: '',
        label: 'Ei valintaa',
        text: 'Ei valintaa'
      })
      return items
    }
  }
}
</script>

<style scoped>
  .rakenne-form {
    text-align: left;
  }

  /*
  #print {
    max-width: 100%;
  }

  @media print {
    #print {
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      min-height: 100%;
      background: #fff;
    }

    .no-print {
      display: none;
    }

    .print-50 {
      max-width: 50%;
    }
  }
  */
</style>



// WEBPACK FOOTER //
// src/components/Rakennetyyppi.vue